import { render, staticRenderFns } from "./homebottom4.vue?vue&type=template&id=00438991&scoped=true"
import script from "./homebottom4.vue?vue&type=script&lang=js"
export * from "./homebottom4.vue?vue&type=script&lang=js"
import style0 from "./homebottom4.vue?vue&type=style&index=0&id=00438991&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00438991",
  null
  
)

export default component.exports